import { useTranslation } from 'react-i18next'
import { KeyValueTable } from '@/features/admin/components/KeyValueTable'

export const ProjectDetailsTableLayout: React.FC<
    Record<
        | 'projectName'
        | 'description'
        | 'startDate'
        | 'endDate'
        | 'trackingType'
        | 'deleted'
        | 'color',
        React.ReactNode
    >
> = ({
    projectName,
    description,
    startDate,
    endDate,
    trackingType,
    deleted,
    color,
}) => {
    const { t } = useTranslation()

    return (
        <KeyValueTable
            rows={[
                {
                    label: t('projects.name'),
                    value: projectName,
                },
                {
                    label: t('projects.description'),
                    value: description,
                },
                { label: t('projects.startDate'), value: startDate },
                { label: t('projects.endDate'), value: endDate },
                {
                    label: t('projects.trackingType'),
                    value: trackingType,
                },
                {
                    label: t('common.active'),
                    value: deleted,
                },
                {
                    label: t('projects.color'),
                    value: color,
                },
            ]}
        />
    )
}
